import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {PopUpSlider} from "./popUpSlider.js";

import imagePanel from '/img/popup/slider-popup-kitcontent-panel.png';
import imageInverter from '/img/popup/slider-popup-kitcontent-inverter.png';
import imageInverter100Days from '/img/popup/slider-popup-kitcontent-100-days-inverter.png';
import imageBattery from '/img/popup/slider-popup-kitcontent-battery.png';
import imagePhone from '/img/popup/slider-popup-kitcontent-phone.png';
import imageFasteners from '/img/popup/slider-popup-kitcontent-fasteners.png';
import imageAll from '/img/popup/slider-popup-kitcontent-all.png';
import imageSurplus from '/img/popup/slider-popup-kitcontent-surplus.png';
import imageContentSurplus from '/img/popup/image-revente-content.png';
import imageBorne from '/img/auto-charger.png';

gsap.registerPlugin(ScrollTrigger, SplitText);
const isMobileFirstLoad = window.innerWidth < 768;

const content = { "panel": {
        "title": "MK-SUN 600Wc",
        "subtitle": "Optez pour les panneaux <span style='color: var(--primary-700);'>les plus puissants du marché</span>, dotés d’une garantie de 40 ans.",
        "description": "<p>Ce panneau solaire est conçu pour maximiser les économies sur le très long terme. Équipé de la technologie TopCon bi-verre qui permet d’optimiser la production d’électricité tout en réduisant les pertes d’énergie. </p> <p>Le panneau dispose également de la technologie Bi-faciale, qui lui permet de produire sur ses 2 faces pour atteindre une puissance totale de 780 Wc dans des conditions optimales.</p> <ul><li>Puissance 600Wc </li><li>Bifacial : +30% de production</li><li>TOPCon bi-verre</li><li>Design full black</li><li>Rendement surfacique : 23,4%</li><li>Taille : 1960 x 1303 x 30 mm </li><li>Garantie produit : 40 ans</li><li>Garantie production : 30 ans à 89.4%</li></ul>"
    },
    "inverter": {
        "title": "Micro-Onduleur WIFI",
        "subtitle": "Connecté, ce micro-onduleur 3000W offre des performances optimales et une garantie record de 25 ans.",
        "description": "<p>Ce micro-onduleur assure une production optimale et indépendante pour chaque panneau solaire garantissant une performance record de votre installation sur la durée (garantie produit 25 ans). Conçu pour gérer 6 panneaux solaires en simultané, l’installation est plus rapide, plus simple et plus sûre avec six fois moins de risque de SAV.</p> <p>Confiants dans la Haute Qualité des composants de ce micro-onduleur, nous offrons une extension de garantie jusqu’à 25 ans, avec dans les très rares cas de survenance, un sav réactif opéré par nos équipes de Lille.</p> <ul><li>Puissance de sortie : 500W par panneau</li><li>Rendement optimal : 97,2%</li><li>Dimensions : 354 x 294 x 60 mm</li><li>Connectivité : Wifi</li><li>Garantie : 25 ans</li></ul>"
    },
    "battery": {
        "title": "Batterie de Stockage",
        "title-light": "en option",
        "subtitle": "Nos batteries MK-SUN Haute Performance permettent le stockage de votre production d’électricité pour vous la restituer le soir et lorsque vos appareils le nécessite.",
        "description": "<p>La batterie de stockage physique permet de consommer 100% de la production d’électricité de vos panneaux solaires et ainsi d’augmenter vos économies de façon spectaculaire.</p><p>3 modèles selon le besoin : 5 kWh, 10 kWh et 15 kWh.\nAvec plus de 6000 cycles, la batterie MK-SUN est le fruit d’une collaboration avec les ingénieurs du géant Soluna. Avec une garantie de 10 ans, elle s’intègre parfaitement dans l’écosystème MK-SUN et est aujourd’hui l’une des batteries les plus robustes du marché.</p>"
    },
    "phone": {
        "title": "Application Connectée",
        "subtitle": "Suivez en temps réel la production de vos panneaux solaires",
        "description": "<p>Obtenez un aperçu précis et détaillé de la production de chaque panneau solaire, avec des données actualisées à la minute. Vous pouvez visualiser l’efficacité de votre installation à tout moment et de n’importe où, directement depuis votre smartphone ou votre tablette.</p><p>L’application propose également un historique détaillé de votre production, vous permettant d’analyser les performances de votre installation sur le long terme. Avec des graphiques et des rapports complets, vous avez toutes les informations nécessaires pour maximiser l’efficacité de votre installation solaire.</p>"
    },
    "revente": {
        "title": "Revendez votre surplus d’énergie",
        "subtitle": "10 centimes d’€/kWh",
        "description": `<ul><li>Puis tarif de rachat révisé annuellement</li><li>Abonnement 3€/mois <strong>offert pendant 2 ans</strong></li></ul><h3>On s’occupe de tout</h3><ul><li>Sans intermédiaire. <strong>Sans engagement</strong></li><li>Éligible pour toutes les installations, <strong>même en autonomie</strong></li><li><strong>Pas de changement de fournisseur</strong></li><li>Démarches administratives incluses</li></ul><h3>Tarification transparente</h3><ul><li>Offre réservée aux clients Mon Kit Solaire</li><li>Souscription MK-Surplus + Consuel : <strong>649€</strong> <s>699€</s></li></ul><img src='${imageContentSurplus}' alt='50€ offerts sur MK-Surplus avec nos offres MK-SUN'>`
    },
    "borne": {
        "title": "Borne de Recharge 7,4 kWh",
        "subtitle": "Pour recharger votre véhicule électrique avec vos panneaux solaires",
        "description": "<p>Fabriquée en Europe, la borne LEKTRI.CO 7,4 kWh est une solution intelligente de recharge de véhicules électriques à partir du surplus de production de vos panneaux solaires et/ou du réseau.</p> <ul><li>3 modes de charge : Power, Hybrid & Green</li><li>Optimise l’autoconsommation</li><li>Détection des heures creuses/heures pleines</li><li>Minuterie programmable</li><li>Application connectée</li></ul> <h3>Comportement des 3 modes de charge</h3><div class=\"flex\"><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"60\" height=\"60\" rx=\"10\" fill=\"#EFEFEF\"/><path d=\"M30.7611 29.2922L36.848 19.3477L27.7176 21.6303L23.1523 33.8042L27.7176 33.0433L24.6741 43.6955L37.6089 28.4781L30.7611 29.2922Z\" stroke=\"#0085FF\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M12.5 30H17.8261\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14.8433 38.75L19.4541 36.0869\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M38.75 45.1566L36.0869 40.5381\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M45.1568 38.75L40.5459 36.0869\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M47.4999 30H42.1738\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M45.1568 21.25L40.5459 23.913\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M21.25 14.8433L23.913 19.4541\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M14.8433 21.25L19.4541 23.913\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg><h4>Power</h4></div><p>Recharger avec la puissance disponible la plus élevé. S'adapte à tous les changements de puissance dans le bâtiment pour éviter les surcharges.</p><div class=\"flex\"><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"60\" height=\"60\" rx=\"10\" fill=\"#EFEFEF\"/><path d=\"M34.4471 48.1915H45.7662C46.6556 48.1915 47.3833 47.4638 47.3833 46.5745V17.4681C47.3833 16.5787 46.6556 15.8511 45.7662 15.8511H29.596C28.7067 15.8511 27.979 16.5787 27.979 17.4681V19.8936\" stroke=\"#3D3D3D\" stroke-miterlimit=\"10\"/><path d=\"M32.8301 15.8511V13.4256C32.8301 12.5363 33.5577 11.8086 34.4471 11.8086H40.9152C41.8045 11.8086 42.5322 12.5363 42.5322 13.4256V15.8511\" stroke=\"#3D3D3D\" stroke-miterlimit=\"10\"/><path d=\"M25.9576 48.1916C33.3253 48.1916 39.298 42.2189 39.298 34.8512C39.298 27.4835 33.3253 21.5107 25.9576 21.5107C18.5899 21.5107 12.6172 27.4835 12.6172 34.8512C12.6172 42.2189 18.5899 48.1916 25.9576 48.1916Z\" stroke=\"#3D3D3D\" stroke-miterlimit=\"10\"/><path d=\"M27.1702 33.6383L27.9787 25.5532L19.8936 36.0639H23.9361L23.1276 44.149L31.2127 33.6383H27.1702Z\" stroke=\"#0085FF\" stroke-linejoin=\"round\"/></svg><h4>Hybrid</h4></div><p>Recharger avec énergie solaire chaque fois que disponible. S’adapte à l’énergie disponible et continue de charger même lorsque la production de photovoltaïque ne suffit pas.</p><div class=\"flex\"><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"60\" height=\"60\" rx=\"10\" fill=\"#EFEFEF\"/><path d=\"M36.1007 41.7959C37.8307 43.5927 44.2824 43.9437 46.5472 39.4141C48.2186 36.0713 46.1795 31.8927 47.199 27.8979C40.9312 29.2017 36.0506 32.9122 35.499 39.038\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M25.2946 30.2217L21.116 44.4289L37.8304 26.0431H31.1446L35.3232 11.8359L18.6089 30.2217H25.2946Z\" stroke=\"#0085FF\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M18.2249 39.6987C14.8736 36.7904 12.7593 32.4948 12.7593 27.7145C12.7593 18.9479 19.8712 11.8359 28.6379 11.8359C28.8468 11.8359 29.0557 11.8359 29.2647 11.8443\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M43.3795 33.6313C41.0311 39.473 35.3148 43.5931 28.6374 43.5931C28.0357 43.5931 27.4507 43.5597 26.8657 43.4928\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M38.3237 15.1367C41.3657 17.4767 43.5302 20.9032 44.249 24.831\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M43.7475 45.3481C43.8896 46.2089 43.8478 47.2619 43.5302 48.0976C39.8447 48.457 35.8082 47.3287 34.3457 42.5317\" stroke=\"#3D3D3D\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg><h4>Green</h4></div><p>Recharger utilisant uniquement l’énergie solaire. Ajuste la puissance de charge à la quantité d’énergie solaire produite. Suspend la charge lorsqu’il n’y a pas assez d’énergie solaire.</p>"
    }}


const slides = [
    {
        image: {
            src: imagePanel,
            alt: 'Ecosystem 1'
        },
        content:
            `<div>
                <h2>${content.panel.title}</h2>
                <h3>${content.panel.subtitle}</h3>
                <div>${content.panel.description}</div>
            </div>`
    },
    {
        image: {
            src: imageInverter,
            alt: 'Ecosystem 1'
        },
        content:
            `<div>
                <h2>${content.inverter.title}</h2>
                <h3>${content.inverter.subtitle}</h3>
                <div>${content.inverter.description}</div>
            </div>`
    },
    {
        image: {
            src: imageBattery,
            alt: 'Ecosystem 1'
        },
        content:
            `<div>
                <h2>${content.battery.title}</h2>
                <h3>${content.battery.subtitle}</h3>
                <div>${content.battery.description}</div>
            </div>`
    },
    {
        image: {
            src: imagePhone,
            alt: 'Ecosystem 1'
        },
        content:
            `<div>
                <h2>${content.phone.title}</h2>
                <h3>${content.phone.subtitle}</h3>
                <div>${content.phone.description}</div>
            </div>`
    },
    {
        image: {
            src: imageSurplus,
            alt: 'Image surplus'
        },
        content: `<div> <h2>${content.revente.title}</h2> <h3>${content.revente.subtitle}</h3> <div>${content.revente.description}</div> </div>`
    },
    {
        image: {
            src: imageBorne,
            alt: 'Borne de recharge véhicule électrique'
        },
        content:
            `<div>
                <h2>${content.borne.title}</h2>
                <h3>${content.borne.subtitle}</h3>
                <div>${content.borne.description}</div>
            </div>`
    }
]
let slidesTeaser = [...slides];
// remove the first slide
//slidesTeaser.shift();

const sliderComposition = new PopUpSlider(slides, {})
sliderComposition.createSlider();

const sliderTeaser = new PopUpSlider(slidesTeaser, {})
sliderTeaser.createSlider();

const dropdowns = document.querySelectorAll('.mksun-content:not(.mksun-content--teaser) .mksun-ecosystem .mksun-block-faq__ctn__dropdown');

const dropdownsTeaser = document.querySelectorAll('.mksun-content--teaser .mksun-ecosystem .mksun-block-faq__ctn__dropdown:not(.mksun-block-faq__ctn__dropdown--disabled)');

dropdowns.forEach((item, index) => {
    item.addEventListener('click', () => {
        sliderComposition.openSlide(index);
    });
})

dropdownsTeaser.forEach((item, index) => {
    item.addEventListener('click', () => {
        sliderTeaser.openSlide(index);
    });
})


if (!isMobileFirstLoad) {
    const tlEcosystem = gsap.timeline({
        scrollTrigger: {
            trigger: '.mksun-ecosystem'
        }
    });

    const titleEcosystem = new SplitText(
        '.mksun-ecosystem .timeline-text-reveal:not(.timeline-text-reveal--lines)',
        {
            type: 'words'
        }
    );

    const linesEcosystem = new SplitText('.mksun-ecosystem .timeline-text-reveal--lines', {
        type: 'lines'
    });

    /*tlEcosystem.to(
        '.mksun-ecosystem__head img',
        {
            y: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power1.out'
        },
        '<'
    );*/

    tlEcosystem.from(
        titleEcosystem.words,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    tlEcosystem.from(
        linesEcosystem.lines,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1
        },
        '<'
    );

    gsap.from(
        dropdowns,
        {
            y: '100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            stagger: 0.1,
            scrollTrigger: {
                trigger: '.mksun-ecosystem .mksun-block-faq__ctn'
            }
        },
        '<'
    );
}